(() => {
    const contactButton = document.querySelector('.contact-pop');
    if (!contactButton) return;
    
    const debounce = (func, delay) => {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    // 添加CSS样式
    const style = document.createElement('style');
    style.textContent = `
        .ai-iframe-container {
            position: fixed;
            bottom: 10px;
            right: 64px;
            width: 640px;
            max-width: 100%;
            height: 88vh;
            z-index: 99999;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
            background: #fff;
            transform: scale(0.3) translate(100px, 100px);
            transform-origin: bottom right;
            opacity: 0;
            visibility: hidden;
            transition: transform 0.25s linear, opacity 0.25s linear, visibility 0.25s linear;
        }
        #zc__sdk__container {
            width: 640px !important;
            height: 88vh !important;
        }
        
        .ai-iframe-container.ai-show {
            transform: scale(1) translate(0, 0);
            opacity: 1;
            visibility: visible;
        }
        

        
        .ai-iframe-header {
            background: linear-gradient(to right, rgb(11, 53, 135), rgb(11, 53, 135));
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 15px;
            color: white;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            font-size: 14px;
            font-weight: 500;
            position: relative;
            overflow: hidden;
        }
        
        
        
        .ai-iframe-title {
            flex: 1;
        }
        
        .ai-iframe-controls {
            display: flex;
            gap: 12px;
        }
        
        .ai-iframe-btn {
            width: 32px;
            height: 32px;
            border: none;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            color: white;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: bold;
            transition: all 0.2s linear;
            transform: scale(1);
        }
        
        .ai-iframe-btn:hover {
            background: rgba(255, 255, 255, 0.6);
            transform: scale(1.05);
        }
        
        .ai-iframe-btn:active {
            transform: scale(0.98);
        }
        
        .ai-iframe-btn.minimize {
            font-size: 16px;
            line-height: 1;
        }
        
        
        .ai-iframe-content {
            height: calc(100% - 56px);
            position: relative;
        }
        
        .ai-iframe-content iframe {
            width: 100%;
            height: 100%;
            border: none;
            display: block;
            opacity: 0;
            transition: opacity 0.3s linear;
        }
        
        .ai-iframe-content iframe.loaded {
            opacity: 1;
        }
        
        .ai-loading {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f8f9fa;
            z-index: 10;
            transition: opacity 0.3s linear;
        }
        
        .ai-loading.hidden {
            opacity: 0;
            pointer-events: none;
        }
        
        .ai-spinner {
            width: 40px;
            height: 40px;
            border: 3px solid #e3e3e3;
            border-top: 3px solid rgb(11, 53, 135);
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        #zc__sdk__container {
            right:64px !important;
        }    
        
        @media (max-width: 768px) {
            .ai-iframe-header{
                height: 40px;
            }
            .ai-iframe-content {
                height: calc(100% - 40px);
            }
            .ai-iframe-container {
                width: 100vw;
                height: 100vh;
                bottom: 0;
                left: 0;
                border-radius: 0;
            }
                 #zc__sdk__container {
                    width: 100vw !important;
                    height: 100vh !important;
                 }
            .ai-iframe-btn {
                width: 24px;
                height: 24px;
            }
            .ai-iframe-btn svg {
                width: 20px;
                height: 20px;
            }
            .ai-iframe-controls {
                gap: 8px;
            }
        }
        

    `;
    document.head.appendChild(style);

    const createIframeAi = () => {
        const container = document.createElement('div');
        container.className = 'ai-iframe-container ai-show';
        
        container.innerHTML = `
            <div class="ai-iframe-header">
                <div class="ai-iframe-title"></div>
                <div class="ai-iframe-controls">
                    <div id="liveChatBtn" class="ai-iframe-btn chatbot" style="display: flex; align-items: center; gap: 8px;cursor: pointer; width: auto;    border-radius: 200px;padding: 0 10px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_87_210)">
                                <path d="M10.3241 17.8124L8.50926 12.3643H1.25L3.06481 17.8124H10.3241ZM10.3241 17.8124H13.9537" stroke="white" stroke-width="1.14286" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M9.03929 11.2382V10.7842C9.03929 9.07167 9.03929 8.21632 8.50755 7.68422C7.97581 7.15212 7.12103 7.15212 5.40966 7.15212C3.69829 7.15212 2.84351 7.15212 2.31177 7.68422C1.78003 8.21632 1.78003 9.07167 1.78003 10.7842V11.2382M11.4907 13.7264H16.9351C17.4164 13.7264 17.878 13.9177 18.2184 14.2583C18.5587 14.5989 18.7499 15.0608 18.7499 15.5425V15.9965C18.7499 16.4781 18.5587 16.94 18.2184 17.2806C17.878 17.6212 17.4164 17.8125 16.9351 17.8125H16.0277M16.0277 9.64033C16.0277 10.122 15.8365 10.5839 15.4962 10.9245C15.1558 11.265 14.6942 11.4564 14.2129 11.4564C13.7316 11.4564 13.27 11.265 12.9296 10.9245C12.5893 10.5839 12.3981 10.122 12.3981 9.64033C12.3981 9.15869 12.5893 8.69677 12.9296 8.3562C13.27 8.01562 13.7316 7.82429 14.2129 7.82429C14.6942 7.82429 15.1558 8.01562 15.4962 8.3562C15.8365 8.69677 16.0277 9.15869 16.0277 9.64033ZM7.22447 4.00354C7.22447 4.48518 7.03327 4.9471 6.69293 5.28767C6.35258 5.62824 5.89098 5.81957 5.40966 5.81957C4.92834 5.81957 4.46673 5.62824 4.12639 5.28767C3.78605 4.9471 3.59484 4.48518 3.59484 4.00354C3.59484 3.52189 3.78605 3.05998 4.12639 2.7194C4.46673 2.37883 4.92834 2.1875 5.40966 2.1875C5.89098 2.1875 6.35258 2.37883 6.69293 2.7194C7.03327 3.05998 7.22447 3.52189 7.22447 4.00354Z" stroke="white" stroke-width="1.14286" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_87_210">
                                <rect width="20" height="20" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <span>Chat with an Agent</span>


                    </div>
                    <button class="ai-iframe-btn minimize" title="hide" style="background: none;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19.7143 8.14265L12.2424 15.6145C12.1086 15.7484 11.8915 15.7484 11.7576 15.6145L4.28572 8.14265" stroke="white" stroke-width="1.71429" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="ai-iframe-content">
                <div class="ai-loading">
                    <div class="ai-spinner"></div>
                </div>
              <iframe src="https://ai.renogy.com"></iframe>
            </div>
        `;
        
        document.body.appendChild(container);
        
        // 添加事件监听器
        const minimizeBtn = container.querySelector('.minimize');
        const iframe = container.querySelector('iframe');
        const loading = container.querySelector('.ai-loading');
        
        // iframe加载完成后隐藏loading
        iframe.addEventListener('load', () => {
            setTimeout(() => {
                loading.classList.add('hidden');
                setTimeout(() => {
                    iframe.classList.add('loaded');
                }, 100); // 先隐藏loading，再显示iframe
            }, 300); // 延迟300ms让用户看到loading效果
        });
        
        // 如果iframe加载失败，也要隐藏loading
        iframe.addEventListener('error', () => {
            loading.innerHTML = `
                <div style="color: #ff4757; font-size: 24px;">⚠️</div>
            `;
        });
        
        minimizeBtn.addEventListener('click', () => {
            container.classList.remove('ai-show');
        });

        document.getElementById('liveChatBtn').addEventListener('click', () => {
            container.classList.remove('ai-show');
            document.querySelector('.zc__sdk__sys__btn').click();
            console.log('live chat2')
        })
        
        return container;
    }

    contactButton.addEventListener('click', debounce(() => {
        const existingContainer = document.querySelector('.ai-iframe-container');
        
        if (existingContainer) {
            if (existingContainer.classList.contains('ai-show')) {
                existingContainer.classList.remove('ai-show');
            } else {
                existingContainer.classList.add('ai-show');
            }
        } else {
            createIframeAi();
        }
    }, 200))
})()